import { useTranslation } from "react-i18next";

const STAT_KEYS = ["created", "restored", "skipped", "failed"] as const;

export function ImportJobResultStats({
  created,
  restored,
  skipped,
  failed,
}: {
  created: number;
  restored: number;
  skipped: number;
  failed: number;
}): React.JSX.Element {
  const { t, i18n } = useTranslation();
  const values = { created, restored, skipped, failed };

  return (
    <div
      className="grid grid-cols-2 gap-2 sm:grid-cols-4"
      data-testid="contact-import-job-stats"
    >
      {STAT_KEYS.map((key) => (
        <div
          key={key}
          className="rounded-md border border-border/70 bg-surface-muted/40 px-2.5 py-2"
        >
          <p className="m-0 text-[0.6875rem] font-medium text-muted">
            {t(`contacts.import.job.count.${key}`)}
          </p>
          <p className="m-0 mt-0.5 text-[1.05rem] font-semibold tabular-nums tracking-[-0.02em] text-foreground">
            {values[key].toLocaleString(i18n.language)}
          </p>
        </div>
      ))}
    </div>
  );
}

export function contactImportJobPercent(
  processed: number,
  total: number | null | undefined,
): number {
  if (total == null || total <= 0) return 0;
  return Math.min(100, Math.round((processed / total) * 100));
}
